import React from 'react';
import { MessageSquare, Mic, Video, ArrowDown } from 'lucide-react';
import { motion } from 'framer-motion';
const layers = [{
  id: 1,
  title: 'Capa 1: ChatGPT',
  subtitle: 'Guiones con lenguaje local',
  icon: MessageSquare,
  color: 'from-emerald-900/40 to-emerald-800/20',
  borderColor: 'border-emerald-500/30'
}, {
  id: 2,
  title: 'Capa 2: ElevenLabs',
  subtitle: 'Clonación de voz natural',
  icon: Mic,
  color: 'from-blue-900/40 to-blue-800/20',
  borderColor: 'border-blue-500/30'
}, {
  id: 3,
  title: 'Capa 3: Canva + CapCut',
  subtitle: 'Montaje visual con videos libres',
  icon: Video,
  color: 'from-purple-900/40 to-purple-800/20',
  borderColor: 'border-purple-500/30'
}];
export function AILayerStack() {
  return <div className="max-w-2xl mx-auto relative py-8" data-id="element-1">
      {/* Connecting line background */}
      <div className="absolute left-8 top-10 bottom-10 w-0.5 bg-gradient-to-b from-[#d4a843]/0 via-[#d4a843]/50 to-[#d4a843]/0 z-0" data-id="element-2" />

      <div className="space-y-4" data-id="element-3">
        {layers.map((layer, index) => <div key={layer.id} className="relative z-10" data-id="element-4">
            <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} className={`flex items-center p-6 rounded-2xl bg-gradient-to-r ${layer.color} border ${layer.borderColor} backdrop-blur-sm shadow-lg hover:translate-x-2 transition-transform duration-300`} data-id="element-5">
              <div className="flex-shrink-0 w-16 h-16 rounded-full bg-[#0a1628] border border-[#d4a843]/40 flex items-center justify-center shadow-inner mr-6" data-id="element-6">
                <layer.icon className="w-8 h-8 text-[#d4a843]" data-id="element-7" />
              </div>
              <div data-id="element-8">
                <h3 className="text-xl md:text-2xl font-bold text-white mb-1 font-serif" data-id="element-9">
                  {layer.title}
                </h3>
                <p className="text-gray-300" data-id="element-10">{layer.subtitle}</p>
              </div>
            </motion.div>

            {index < layers.length - 1 && <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} transition={{
          delay: 0.5 + index * 0.2
        }} className="flex justify-center py-2 pl-8" data-id="element-11">
                <ArrowDown className="w-6 h-6 text-[#d4a843]/60 animate-bounce" data-id="element-12" />
              </motion.div>}
          </div>)}
      </div>
    </div>;
}